import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Typist from "react-typist";
import $ from 'jquery';
import Configs from "../../editable-stuff/configurations.json";

const CourseEval = () => {
  const icons = Configs.icons;

  // const [backgroundType, setBackgroundType] = useState(Configs.backgroundType);
  const [hoverstatus, setHoverstatus] = useState([
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons"
  ]);

  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })

  const toggleHover = data => {
    const newhoverStatus = [...hoverstatus];

    if (data.event === "enter") {
      newhoverStatus[data.icon.id] = "socialiconshover";
      return setHoverstatus(newhoverStatus);
    } else if (data.event === "leave") {
      newhoverStatus[data.icon.id] = "socialicons";
      return setHoverstatus(newhoverStatus);
    }
  };
  return (
    <div> 
      <div
        id="CourseEvalHeader"
        className="jumbotron jumbotron-fluid bg-transparent bgstyle text-light min-vh-auto d-flex align-content-center align-items-center flex-wrap m-0"
      >
        <div className="container container-fluid text-center ">
          <h1 className="display-3">Course Evaluation System</h1>
          <Typist className="lead" cursor={{ hideWhenDone: true }}>
          Students may anonymously rate a lecture and professors can see the rating filtered by course and class.</Typist>
          <div  style={{paddingTop: "20px"}}>
            <a
              className="btn btn-outline-light btn-lg"
              href="https://github.com/dannyjanani/Course-Evaluation-System"
              target="_blank"
              rel="noreferrer noopener"
              role="button"
              aria-label="Resume/CV"
            >
              Github Page
            </a>
          </div>
          <div className="p-6" style={{paddingTop:"20px", paddingBottom:"40px"}}>
            {icons.map(icon => (
              <a
                key={icon.id}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
              >
                <i
                  className={`fab ${icon.image}  fa-3x ${hoverstatus[icon.id]}`}
                  onMouseOver={() => toggleHover({ icon, event: "enter" })}
                  onMouseOut={() => toggleHover({ icon, event: "leave" })}
                />
              </a>
            ))}
          </div>
          <Link className="btn btn-outline-light btn-lg" role="button" to="/">Home</Link>
          &nbsp;&nbsp;&nbsp;
          <Link className="btn btn-outline-light btn-lg" role="button" to="/resume">Resume</Link>
          &nbsp;&nbsp;&nbsp;
          <Link className="btn btn-outline-light btn-lg" role="button" to="/projects">Projects</Link>
          {/* &nbsp;&nbsp;&nbsp;
          <Link className="btn btn-outline-light btn-lg" role="button" to="/vocals">Vocals</Link> */}
        </div>
      </div>
      <div id="CourseEval" className="jumbotron jumbotron-fluid bg-transparent min-vh-100 m-0">
      <div className="container container-fluid p-5">
          <div className="accordion" id="CourseEvalAccordian">
            <div className="card">
              <div className="card-header" id="CourseEvalOverview">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={{color:"black", fontWeight:"bold"}}>
                    Project Overview
                  </button>
                </h2>
              </div>

              <div id="collapseOne" className="collapse show" aria-labelledby="CourseEvalOverview" data-parent="#CourseEvalAccordian">
                <div className="card-body">
                Professors love hearing feedback from students on how they can improve the lecture and make it more insighting for the students. 
                Often, I had professors that would hand out a paper at the end of every lecture for students to give anonymous feedback about the lecture. 
                This would be very time consuming reading every paper, every lecture and sorting them for the records. 
                This project allows for a professor to login and add courses that they teach and the system will automatically 
                generate a session ID based on the weekly evaluation times and start, end days of the semester. These sessions contain a randomly generated evaluation 
                password for the students which the professor can change at any time. The professor can view reports for each session for all sessions of a course over the semester. 
                The professor can also see a chart for every report. 
                This project allows for a student to login to the courses he's enrolled in, and anonymously leave feedback for professors of the corresponding class and date.
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="CourseEvalGoals">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo" style={{color:"black", fontWeight:"bold"}}>
                    Project Goals
                  </button>
                </h2>
              </div>
              <div id="collapseTwo" className="collapse show" aria-labelledby="CourseEvalGoals" data-parent="#CourseEvalAccordian">
                <div className="card-body">
                  <ul style={{paddingLeft: "25px"}}>
                    <li>Anonymous course evaluation system for students and professors</li>
                    <li>Professor:
                      <ul style={{paddingLeft: "25px"}}>
                        <li>Can login with his username and password.</li>
                        <li>The system automatically generates evaluation sessions based on the weekly evaluation times and the start and end days of the semester.</li>
                        <li>The auto-generated sessions contain a randomly generated evaluation password for the students.</li>
                        <li>The Professor can change the evaluation password at any time.</li>
                        <li>The system will automatically create or delete evaluation session accordingly.</li>
                        <li>The professor can also manually add, edit, and delete evaluation sessions and courses.</li>
                        <li>The courses the professor is currently teaching will be visible in the dashboard.</li>
                        <li>A professor can view what students think about a specific lecture over the course of a semester.</li>
                        <li>The professor can access a chart view for an overall summary.</li>
                        <li>Professor will hopefully be able to improve based on the feedback in subsequent lectures.</li>
                      </ul>
                    </li>
                    <li>Student:
                      <ul style={{paddingLeft: "25px"}}>
                        <li>Can login with his username and password.</li>
                        <li>The courses the student is currently taking will be visible in the dashboard.</li>
                        <li>A student can anonymously rate and comment a specific lecture.</li>
                        <li>Student will hopefully have a better experience in subsequent lectures.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="CourseEvalGallery">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive" style={{color:"black", fontWeight:"bold"}}>
                    Gallery
                  </button>
                </h2>
              </div>
              <div id="collapseFive" className="collapse show" aria-labelledby="CourseEvalGallery" data-parent="#CourseEvalAccordian">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <h5>Student Login</h5>
                      <img src={require('./Media/CourseEval/Student Login Verification.png')} alt=""/>
                    </div>
                    <div className="col-md-6">
                      <h5>Course Dashboard</h5>
                      <img src={require('./Media/CourseEval/Course Dashboard.png')} alt=""/>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <h5>Rating Page</h5>
                      <img src={require('./Media/CourseEval/Rating Page.png')} alt=""/>
                    </div>
                    <div className="col-md-6">
                      <h5>Rating Posted</h5>
                      <img src={require('./Media/CourseEval/Rating Posted.png')} alt=""/>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <h5>Rating Changed</h5>
                      <img src={require('./Media/CourseEval/Rating Changed.png')} alt=""/>
                    </div>
                    <div className="col-md-6">
                      <h5>Professor Login</h5>
                      <img src={require('./Media/CourseEval/Professor Login.png')} alt=""/>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md">
                      <div className="embed-responsive embed-responsive-4by3">
                        <iframe title="Testing" className="embed-responsive-item" src='https://player.vimeo.com/video/432714107' frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="CourseEvalUsage">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour" style={{color:"black", fontWeight:"bold"}}>
                    Skills Used
                  </button>
                </h2>
              </div>
              <div id="collapseFour" className="collapse show" aria-labelledby="CourseEvalUsage" data-parent="#CourseEvalAccordian">
                <div className="card-body">
                  <ul style={{paddingLeft: "25px"}}>
                    <li>Software:
                      <ul style={{paddingLeft: "25px"}}>
                        <li>MySQL Workbench</li>
                      </ul>
                    </li>
                    <li>Languages:
                      <ul style={{paddingLeft: "25px"}}>
                        <li>HTML</li>
                        <li>JavaScript (JQuery)</li>
                        <li>Google Charts API</li>
                        <li>CSS</li>
                        <li>Python</li>
                        <li>DJango Framework</li>
                        <li>MySQL</li>
                        <li>PostgreSQL</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseEval;